<template>
    <div class="main">
        <div v-show="flag==0" class="no_matching">
            <div class="img"><img src="@/assets/img/newpage/apply_no_pass.png"></div>
            <div class="content">初审未通过</div>
            <div class="desc">暂不符合该产品的准入资格，您可查看其他订单审核进度</div>
            <div class="btn" @click="toSee"><span>去查看</span></div>
        </div>
        <div v-show="flag==1" class="have_product">
            <div class="title">
                <img src="@/assets/img/newpage/apply_point.png" alt=""
                     style="width: 0.22rem;height: 0.22rem;vertical-align: middle;margin-bottom: 0.07rem;">
                <span class="txt">初审未通过</span>
            </div>
            <div class="desc">
                <span>暂不符合该产品的准入资格，您可尝试申请其他产品</span>
            </div>
            <div class="content">
                <div class="access"><img src="@/assets/img/newpage/apply_access.png" alt=""></div>
                <div class="description">最高可借额度(元)</div>
                <div class="money">200,000</div>
                <div class="btn" @click="toApply"><span>立即申请</span></div>
                <div>
                    <div style="background: #fff;"><img src="@/assets/img/newpage/apply_step.png" style="width: 90%;">
                    </div>
                </div>
            </div>
            <div class="footer"><span style="color: #FF514A;">平台提醒用户注意保护个人隐私</span>，不要相信以“银行卡错误”、“账户异常”、“征信差”等要求缴纳“手续费、保证金、解冻费”等，不点击陌生链接、不给陌生账户转账等，<span
                    style="color: #FF514A;">请提高安全意识，谨防诈骗</span></div>
        </div>
        <div v-show="flag==2" class="matching">
            <div class="title">
                <img src="@/assets/img/newpage/apply_point.png" class="point">
                <span class="txt">初审未通过</span>
            </div>
            <div class="desc">
                <span>您可以尝试申请以下金融机构，无需补充材料</span>
            </div>

            <div class="content">
                <div v-for="(item,index) in agencys" :key="index">
                    <div class="info">
                        <div class="img">
                            <img :src="item.icon" alt="" style="width: 100%;height: 100%;">
                        </div>
                        <div class="company">{{item.name}}</div>
                    </div>
                    <div class="bottom">
                        <div>
                            <div class="money">{{item.money}}</div>
                            <div class="txt">可借额度(元)</div>
                        </div>
                        <div>
                            <div class="month">{{item.period}}</div>
                            <div class="txt">贷款期限</div>
                        </div>
                        <div v-if="!item.checked" class="check" @click="check(index)">
                            <img src="@/assets/img/newpage/apply_no_selected.png" style="width: 100%;height: 100%">
                        </div>
                        <div v-else class="check" @click="check(index)">
                            <img src="@/assets/img/newpage/apply_selected.png" style="width: 100%;height: 100%;">
                        </div>
                    </div>
                    <div class="line"></div>
                </div>
                <div class="selected">
                    <div class="check" v-if="allSelect">
                        <img src="@/assets/img/newpage/apply_selected.png" style="width: 100%;height: 100%;">
                    </div>
                    <div class="check" v-else>
                        <img src="@/assets/img/newpage/apply_no_selected.png" style="width: 100%;height: 100%;">
                    </div>
                    <div class="txt" @click="selectAll">全选<span>可一键选择全部机构</span></div>
                </div>

                <div class="selected" style="margin-top: 0.05rem;">
                    <div class="check"
                         v-if="xySelect" @click="xySelect=!xySelect">
                        <img src="@/assets/img/newpage/apply_selected.png" style="width: 100%;height: 100%;">
                    </div>
                    <div class="check" v-else
                         @click="xySelect=!xySelect">
                        <img src="@/assets/img/newpage/apply_no_selected.png" style="width: 100%;height: 100%;">
                    </div>
                    <div class="txt">申请即代表阅读并同意<span>《个人信息授权书》</span></div>
                </div>
                <div class="btn" @click="downPayment"><span>咨询下款</span></div>
            </div>

            <div class="footer"><span style="color: #FF514A;">平台提醒用户注意保护个人隐私</span>，不要相信以“银行卡错误”、“账户异常”、“征信差”等要求缴纳“手续费、保证金、解冻费”等，不点击陌生链接、不给陌生账户转账等，<span
                    style="color: #FF514A;">请提高安全意识，谨防诈骗</span></div>

            <van-popup v-model:show="toastShow" :round="true" :close-on-click-overlay="false" :closeable="true">
                <div class="carToast">
                    <div class="tit">请填写车辆型号</div>
                    <div class="txt">补充真实的车辆信息 可提高借款通过率</div>
                    <div class="line"></div>
                    <div class="input"><input type="text" placeholder="请输入车辆型号，如奥迪A4、大众途昂" v-model="carModel"></div>
                    <div class="btn" @click="submitCarModel"><span>确认提交</span></div>
                </div>
            </van-popup>
        </div>

        <Loading :isShow="loading"></Loading>
    </div>
</template>

<script>
    import Loading from "@/components/loading";

    export default {
        name: "applyResult",
        components: {
            Loading
        },
        data() {
            return {
                loading: false, //加载
                flag: 0, //根据flag判断展示出什么样式(值为0,1,2)
                xySelect: false, //选择协议
                allSelect: false, //全选
                toastShow: false, //车型弹框展示
                car51: "26car", //51车信贷
                agencys: [], //符合的机构列表
                carModel: "",  //车型信息
            }
        }, created() {
            this.util.title('申请结果');
            this.checkIfAllApply();
        }, methods: {
            checkIfAllApply() {
                this.loading = true;
                this.$get("/app/v1/appHead/product/applyResult/ifAllApply")
                    .then((res) => {
                        if (res.code == 200) {
                            if (res.data) {
                                this.getConformAgencys();
                            } else {
                                this.loading = false;
                                this.flag = 1;
                            }
                        } else {
                            this.loading = false;
                            this.util.toast({msg: res.message});
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                    });
            }, getConformAgencys() {
                this.$get("/app/api/v1/order/getConformAgencys")
                    .then((res) => {
                        if (res.code == 200) {
                            this.agencys = res.data.agencys;
                            this.loading = false;
                            if (this.agencys.length > 0) {
                                this.flag = 2;
                            } else {
                                this.flag = 0;
                            }
                        } else {
                            this.loading = false;
                            this.util.toast({msg: res.message});
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                    });
            }, check(index) {
                this.agencys[index].checked = !this.agencys[index].checked;
                this.allSelect = this.agencys.filter(item => item.checked).length == this.agencys.length;
            }, selectAll() {
                this.allSelect = !this.allSelect;
                this.agencys.forEach(e => {
                    e.checked = this.allSelect;
                })
            }, toSee() {
                this.$router.push({
                    path: "/loan/applyStatus",
                    query: {orderType: 1, webRefresh: 1},
                });
            }, toApply() {
                let json = {
                    pageUrl: '77xyPrefix/?Page=7&type=1'
                }
                try {
                    window.webkit.messageHandlers.toProductDetail.postMessage(json);//ios
                } catch (err) {
                    window.AppJs.toProductDetail(JSON.stringify(json));//android
                }
            }, downPayment() {
                if (!this.xySelect) {
                    this.util.toast({msg: "请先勾选协议"})
                    return;
                }
                var list = [];
                var car51Id = 0;
                this.agencys.forEach(e => {
                    if (e.checked) {
                        list.push(e.agencyCityId)
                        if (e.fixedName == this.car51) {
                            car51Id = e.agencyCityId;
                        }
                    }
                })
                if (car51Id == 0) {  //不包含51车信贷
                    var citys = list.join(",");
                    let param = {
                        agencyCityIds: citys
                    };
                    this.postOrder(param, 0);
                } else { //包含51车信贷
                    if (list.length > 1) {  //先让其它的机构成单
                        let index = list.indexOf(car51Id);
                        list.splice(index, 1)
                        var citys = list.join(",");
                        let param = {
                            agencyCityIds: citys
                        };
                        this.postOrder(param, 1);
                    } else {
                        this.toastShow = true;
                    }
                }
            }, submitCarModel() {
                var car51Id = 0;
                this.agencys.forEach(e => {
                    if (e.fixedName == this.car51) {
                        car51Id = e.agencyCityId;
                    }
                })
                let param = {
                    agencyCityIds: car51Id,
                    carModel: this.carModel
                };
                this.postOrder(param, 0);
                this.toastShow = false;
            }, postOrder(param, source) {
                this.$post("/app/api/v1/order/agency/postOrder", param)
                    .then(res => {
                        if (res.code == 200) {
                            if (source == 0) {
                                console.log("回到首页...")
                                this.util.toClientPath(1)
                            } else {
                                this.getConformAgencys();
                                this.util.toast({msg: "申请成功,可前往我的-申请中查看"})
                                this.toastShow = true;
                            }
                        } else {
                            this.util.toast({msg: res.message});
                        }
                    }).catch(err => {

                })
            },


        }
    }
</script>

<style scoped>
    * {
        margin: 0px;
        padding: 0px;

    }

    .main {
        background: #F9F9FA;
    }

    ::-webkit-input-placeholder {
        /* WebKit browsers，webkit内核浏览器 */
        font-size: 0.14rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    :-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        font-size: 0.14rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    ::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        font-size: 0.14rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    :-ms-input-placeholder {
        /* Internet Explorer 10+ */
        font-size: 0.14rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    /** flag=0的样式开始 **/
    .no_matching {
        text-align: center;
    }

    .no_matching .img {
        width: 1.09rem;
        height: 1.1rem;
        margin: 0rem auto;
        padding-top: 0.2rem;
    }

    .no_matching .img img {
        width: 100%;
        height: 100%;
    }

    .no_matching .content {
        font-size: 0.16rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        margin-top: 0.1rem;
    }

    .no_matching .desc {
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    .no_matching .btn {
        width: 90%;
        height: 0.5rem;
        background: linear-gradient(132deg, #59A3FC 0%, #3C64F6 100%);
        box-shadow: 0rem 0.06rem 0.1rem 0rem #E4EEFA;
        border-radius: 0.25rem;
        text-align: center;
        line-height: 0.5rem;
        margin: 0.2rem auto;
    }

    .no_matching .btn span {
        font-size: 0.17rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
    }

    /** flag=0的样式结束 **/

    /** flag=1的样式开始 **/
    .have_product {
        width: 100%;
        height: 1.81rem;
        background: url("../../assets/img/newpage/apply_bg.png");
        background-size: cover;
    }

    .have_product .title {
        width: 100%;
        text-align: center;
        margin-bottom: 0.2rem;
        padding-top: 0.3rem;
    }

    .have_product .title .txt {
        font-size: 0.18rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        margin-left: 0.1rem;
    }

    .have_product .desc {
        width: 90%;
        height: 0.25rem;
        background: rgb(52, 99, 232);
        border-radius: 0.04rem;
        margin: 0rem auto;
        text-align: center;
        line-height: 0.25rem;
    }

    .have_product .desc span {
        font-size: 0.1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
    }

    .have_product .content {
        width: 90%;
        background: #fff;
        margin: 0rem auto;
        border-radius: 0.08rem;
        text-align: center;
    }

    .have_product .content .access {
        width: 0.97rem;
        height: 0.3rem;
        margin: 0rem auto;
    }

    .have_product .content .access img {
        width: 100%;
        height: 100%
    }

    .have_product .content .description {
        font-size: 0.14rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        margin-top: 0.05rem;
    }

    .have_product .content .money {
        font-size: 0.64rem;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #333333;
    }

    .have_product .content .btn {
        width: 90%;
        height: 0.5rem;
        background: linear-gradient(132deg, #59A3FC 0%, #3C64F6 100%);
        border-radius: 0.25rem;
        text-align: center;
        line-height: 0.5rem;
        margin: 0rem auto;
        margin-bottom: 0.2rem;
    }

    .have_product .content .btn span {
        font-size: 0.16rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
    }

    .have_product .footer {
        width: 90%;
        font-size: 0.11rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin: 1rem auto;
        text-align: center;
    }

    /** flag=1的样式结束 **/

    /** flag=2的样式开始 **/
    .matching {
        width: 100%;
        height: 1.81rem;
        background: url("../../assets/img/newpage/apply_bg.png");
        background-size: cover;
    }

    .matching .title {
        width: 100%;
        text-align: center;
        margin-bottom: 0.2rem;
        padding-top: 0.3rem;
    }

    .matching .title .point {
        width: 0.22rem;
        height: 0.22rem;
        vertical-align: middle;
        margin-bottom: 0.07rem;
    }

    .matching .title .txt {
        font-size: 0.18rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        margin-left: 0.1rem;
    }

    .matching .desc {
        width: 90%;
        height: 0.25rem;
        background: rgb(52, 99, 232);
        border-radius: 0.04rem;
        margin: 0rem auto;
        text-align: center;
        line-height: 0.25rem;
    }

    .matching .desc span {
        font-size: 0.1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
    }

    .matching .content {
        width: 90%;
        background: #fff;
        margin: 0rem auto;
        border-radius: 0.08rem;
        text-align: center;
        border: 1px solid #fff;
    }

    .matching .content .info {
        display: flex;
        padding: 0.2rem 0.1rem;
    }

    .matching .content .info .img {
        width: 0.2rem;
        height: 0.2rem;
        border-radius: 0.03rem;
        margin-right: 0.1rem;
    }

    .matching .content .info .company {
        font-size: 0.16rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2F2F2F;
    }

    .matching .content .bottom {
        display: flex;
        justify-content: space-between;
        padding: 0rem 0.1rem;
    }

    .matching .content .bottom .money {
        font-size: 0.18rem;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #FF514A;
    }

    .matching .content .bottom .month {
        font-size: 0.18rem;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #282727;
    }

    .matching .content .bottom .check {
        width: 0.27rem;
        height: 0.27rem;
    }

    .matching .content .line {
        width: 100%;
        height: 0.04rem;
        background: rgb(246, 246, 246);
        margin-top: 0.1rem;
    }

    .matching .content .selected {
        display: flex;
        margin-top: 0.1rem;
        margin-left: 0.1rem;
    }

    .matching .content .selected .check {
        width: 0.12rem;
        height: 0.12rem;
        margin-right: 0.05rem;
        margin-top: -0.02rem;
    }

    .matching .content .txt {
        font-size: 0.1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    .matching .content .txt span {
        font-size: 0.1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #527AF5;
    }

    .matching .content .btn {
        width: 90%;
        height: 0.45rem;
        background: linear-gradient(132deg, #59A3FC 0%, #3C64F6 100%);
        border-radius: 0.25rem;
        text-align: center;
        line-height: 0.45rem;
        margin: 0.2rem auto;
    }

    .matching .content .btn span {
        font-size: 0.16rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
    }


    .matching .footer {
        width: 90%;
        font-size: 0.11rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin: 1rem auto;
        text-align: center;
    }

    .matching .carToast {
        width: 2.95rem;
        background: #FFFFFF;
        text-align: center;
    }

    .matching .carToast .tit {
        font-size: 0.21rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        margin-top: 0.2rem;
        margin-bottom: 0.05rem;
    }

    .matching .carToast .txt {
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FF514A;
    }

    .matching .carToast .line {
        width: 100%;
        height: 1px;
        border-top: 1px dashed #191919;
        margin: 0.1rem auto;
    }

    .matching .carToast .input {
        margin: 0.15rem auto;
    }

    .matching .carToast input {
        width: 2.61rem;
        height: 0.5rem;
        background: #F5F5F5;
        border-radius: 0.08rem;
        font-size: 0.14rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000;
        text-indent: 0.1rem;

    }

    .matching .carToast .btn {
        width: 2.61rem;
        height: 0.5rem;
        background: linear-gradient(132deg, #59A3FC 0%, #3C64F6 100%);
        border-radius: 0.25rem;
        text-align: center;
        line-height: 0.5rem;
        margin: 0.25rem auto;
        margin-bottom: 0.5rem;
    }

    .matching .carToast .btn span {
        font-size: 0.18rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
    }

    /** flag=2的样式结束 **/


</style>
